module.exports = __webpack_public_path__ + "static/img/zhaopu-bg.ce3576c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/zhaopu-bg.png
// module id = DO0b
// module chunks = 1